import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../_environments/environment';
import { Store, Storetype } from '../_model/postalcodedelivery';
import { Countrycode, UrlParameters } from '../_model/shared';
import { Weekday } from '../_model/weeks';

@Injectable()
export class StoreService {

  constructor(
    private _http: HttpClient
  ) {
  }

  findStores(countrycode: Countrycode, postalcode: string, weekday: Weekday = null): Observable<Store[]> {
    if (!countrycode || !postalcode) return of(null)

    const params = new UrlParameters();
    params.addParameter('countryCode', countrycode);
    params.addParameter('postalcode', postalcode);
    if(weekday)
      params.addParameter('dayofweek', weekday);

    return this._http.get(environment.apiserver + 'stores/v1/stores/find' + params.toString()).pipe(
      map((response: Store[]) => {
        response.forEach(r => r = this.setStoredata(r))
        return <Store[]>response;
      })
      , catchError(this.handleError)
    );
  }

  getStore(storeid: number): Observable<Store> {
    const params = new UrlParameters();

    if (!storeid ) {
      return of(null)
    }

    return this._http.get(environment.apiserver + 'stores/v1/stores/' + storeid + params.toString()).pipe(
      map((response: Store) => {
        return this.setStoredata(response)
      })
      , catchError(this.handleError)
    );
  }

  private setStoredata(store: Store): Store {
    store.calculatedDistance = null;
    if (store.distance) {
      store.calculatedDistance = store.distance >= 1 ? (Math.round(store.distance * 10) / 10) + 'km' : Math.round(store.distance * 1000) + 'm'
    }
    store.storedata = store.name + ", " + store.address + " " + store.postalcode + " " + store.city;

    return store;
  }

  private handleError(error: Response) {
    if (error.status === 400) {
      return throwError(() => 'Bad request');
    }
    return throwError(() => error || 'Server error');

  }

}
